export const normalizeContentfulAssetUrl = (url) => 'https:' + url;